import {ApiConnection} from '../message/ApiConnection';
import {BaseWrapper} from '../../../allkey/framework/parameters/BaseWrapper';
import {BasicScenario} from '../../../allkey/framework/parameters/BasicScenario';
import {ConnectionCriteria} from './ConnectionCriteria';

export class ApiConnectionWrapper extends BaseWrapper<ApiConnection, ConnectionCriteria, BasicScenario>  {}

